import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
import { Loader } from "./ProtectedRoute";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate(data.role === "admin" ? "/admin" : "/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => {
        setUser(false);
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUser]);

  return <Loader />;
}
